import React from "react";
import { Alternate } from "../../model/language";
import Link from "../Link/Link";
import { getLanguageFromCode, Language } from "../../i18n/Language";
import { MainMenuButton } from "./ToolbarRightNav";
import styles from "./LanguageList.module.scss";
import classNames from "classnames";
import Text, { TextVariant } from "../Text/Text";

interface LanguageListProps {
  variant?: TextVariant;
  alternates: Alternate[];
  className?: string;
  setShowLanguage?: (value: boolean) => void;
}

const LanguageList = React.forwardRef(
  (
    {
      alternates,
      className,
      variant = "toolbarDefaultLight",
      setShowLanguage
    }: LanguageListProps,
    ref?: React.Ref<HTMLDivElement>
  ) => {
    const helpTranslateString = "Help translate";
    return (
      <div ref={ref} className={classNames(styles.root, className)}>
        <ul>
          {/* Only shown for mobile nav. */}
          {setShowLanguage && (
            <MainMenuButton onClick={() => setShowLanguage(false)} />
          )}
          {alternates
            .filter(a => !a.fallback)
            .map(alternate => {
              const { language, url } = alternate;
              return (
                <li key={language}>
                  <Link to={url}>
                    <Text
                      data-content={getLanguageFromCode(language)}
                      variant={variant}
                      as="span"
                    >
                      <Language code={language} />
                    </Text>
                  </Link>
                </li>
              );
            })}
          <li key="info">
            <Link to="/translate/">
              <Text
                data-content={helpTranslateString}
                variant={variant}
                as="span"
              >
                {helpTranslateString}
              </Text>
            </Link>
          </li>
        </ul>
      </div>
    );
  }
);

export default LanguageList;
